import { getJson } from '@/shared/api/client';
import { briefSchema, documentDetailSchema, whatChangedSchema } from './schemas';

export const fetchBrief = (id: string, signal?: AbortSignal) =>
  getJson(`/documents/${id}/brief`, briefSchema, signal ? { signal } : {});

export const fetchDocument = (id: string, signal?: AbortSignal) =>
  getJson(`/documents/${id}`, documentDetailSchema, signal ? { signal } : {});

export const fetchWhatChanged = (id: string, signal?: AbortSignal) =>
  getJson(`/documents/${id}/what-changed`, whatChangedSchema, signal ? { signal } : {});
